import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Home from './../views/Home.vue'
import About from './../views/About.vue'
import Dashboard from './../views/Dashboard.vue'
import Login from './../views/Login.vue'
import OrganismCards from './../views/OrganismCards.vue'
import OrganismCardForm from './../views/OrganismCardForm.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
          path: '*',
          component: OrganismCards
    },
    {
      path: '/',
      name: 'organismCards',
      component: OrganismCards
    },
    {
      path: '/orgcardform',
      name: 'orgcardform',
      component: OrganismCardForm
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    }
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './../views/About.vue')
    // },
    // {
    //   path: '/dashboard',
    //   name: 'dashboard',
    //   component: Dashboard,
    //     meta: {
    //       requiresAuth: true
    //     }
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

export default router
